import * as React from "react";
const SvgEditLine = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.39976 6.2L2.99976 12.6V15.8H6.19976L9.39976 12.6L12.5998 9.4M9.39976 6.2L12.5998 3L15.7998 6.2L12.5998 9.4M9.39976 6.2L12.5998 9.4", stroke: "#1A1A1A", style: {
  stroke: "#1A1A1A",
  stroke: "color(display-p3 0.1020 0.1020 0.1020)",
  strokeOpacity: 1
}, strokeWidth: 1.41, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgEditLine;
